import api from '../../../services/api.service';
import * as utils from '../../../utils';
export const types = {
    SET_VALUE: 'pedidosAguaPlanejamentoSetValue',
    SET_CNPJ: 'pedidosAguaPlanejamentoSetCNPJ',
    SET_NAME: 'pedidosAguaPlanejamentoSetName',
    SET_PERIOD: 'pedidosAguaPlanejamentoSetPeriod',
    SET_SHOW_CARRIER: 'pedidosAguaPlanejamentoetSethowCarrier',
    SET_SHOW_PERIOD: 'pedidosAguaPlanejamentoetSethowPeriod',
    LOADER_SHOW: 'loaderShow',
    LOADER_HIDDEN: 'loaderHide'
}

export function setValue(value) {
    return {
        type: types.SET_VALUE,
        value
    }
}


export function setCNPJ(carrier) {
    return {
        type: types.SET_CNPJ,
        carrier,
    }
}

export function setName(name) {
    return {
        type: types.SET_NAME,
        name,
    }
}

export function setPeriod(period) {
    return {
        type: types.SET_PERIOD,
        period,
    }
}

export function setShowCarrier(showCarrier) {
    return {
        type: types.SET_SHOW_CARRIER,
        showCarrier,
    }
}

export function setShowPeriod(showPeriod) {
    return {
        type: types.SET_SHOW_PERIOD,
        showPeriod,
    }
}

export function loaderShow() {
    return {
        type: types.LOADER_SHOW,
        async: true,
    }
}

export function loaderHide() {
    return {
        type: types.LOADER_HIDDEN,
        async: false,
    }
}

export function load() {
    return (dispatch, getState) => {
        const state = getState().crudPedidosAguardPlanejamento.pedidosAguardPlanejamento;
        const filter = {
            carrierDocument: state.filters.carrier.documentNumber || "",
            period: state.filters.period.period || "CURRENT_MONTH"
        }
        console.log("filter=", filter)
        const URL = `/api/v1/lognex/reports/indicators/pedidosAguardPlanejamento`;
        dispatch(loaderShow())
        api.post(URL, filter)
            .then(({ data }) => { 
                const { countPedidosAguaPlanejamento = 0 } = data.data;
                dispatch(setValue(countPedidosAguaPlanejamento))
                dispatch(loaderHide())
            })
            .catch((error) => {
                console.log(error)
                dispatch(loaderHide())
            })
    }
}

